import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** POST /login {email, password} => {token, refresh_token, refresh_token_expiration} */
export default class LoginModel extends AbstractApiModel {
  protected _path = '/login';

  @doc.string declare token: string;
  @doc.string declare refresh_token: string;
  /** Timestamp (s) d'expiration du refresh token */
  @doc.number declare refresh_token_expiration: number;
}
